import { Component, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { ConfirmationService, MessageService } from 'primeng/api';
import { firstValueFrom } from 'rxjs';
import { RxFormBuilder, RxFormGroup } from '@rxweb/reactive-form-validators';
import { FormValidatorService } from 'src/app/core/services/form-validator.service';
import { ContractCapability } from '../../_types/contract-capability';
import { ContractCapabilitiesService } from '../../_services/contracts-capabilities.service';
import { CapabilitiesService } from 'src/app/modules/common/_services/capabilities.service';
import { Filter, FilterOperation } from 'src/app/core/jsonapi/filter';
import { FilterBuilder } from 'src/app/core/jsonapi/filters-builder';
import { LoginService } from 'src/app/modules/login/login.service';

@Component({
    selector: 'app-contract-capabilities-detail',
    templateUrl: './capabilities-detail.component.html',
    styleUrls: ['./capabilities-detail.component.scss'],
    standalone: false
})
export class ContractCapabilitiesDetailComponent {
  public contractCapabilityFormGroup!: RxFormGroup;

  public contractCapability: ContractCapability = new ContractCapability();
  public capabilities: any[] = [];

  public allowWrite: boolean = false;
  public allowDelete: boolean = false;

   
  public selectedCapabilitiesIds: any[]=[];


  constructor(
    private contractCapabilitiesService: ContractCapabilitiesService,
    private config: DynamicDialogConfig,
    private messageService: MessageService,
    private dynamicDialogRef: DynamicDialogRef,
    private confirmationService: ConfirmationService,
    private capabilitiesService: CapabilitiesService,
    private formBuilder: RxFormBuilder,
    private formValidationService: FormValidatorService,
    private loginService: LoginService
  ) {
    this.contractCapabilityFormGroup = this.formBuilder.formGroup<ContractCapability>(this.contractCapability) as RxFormGroup;
  }

  ngOnInit(): void {

    if (this.config.data.contractCapabilityId) {
      this.loadContractCapability(this.config.data.contractCapabilityId);
    } else {
      this.contractCapability.contractId = this.config.data.contractId;
    }
    this.loadCapabilities();
    this.allowWrite = this.loginService.hasPermission("COMPANIES.WRITE");
    this.allowDelete = this.loginService.hasPermission("COMPANIES.DELETE");
  }

  async loadContractCapability(id: string) {

    this.contractCapability = await firstValueFrom(this.contractCapabilitiesService.get(id));

    this.contractCapabilityFormGroup.patchValue(this.contractCapability);
    this.selectedCapabilitiesIds = this.contractCapability.capabilityId ? [this.contractCapability.capabilityId] : [];
  }

  async load(event: any){
    if(event.filter.length > 2) this.loadCapabilities(event.filter);
  }

  async loadCapabilities(filter: string = "") {

    let filters = {
      name: new Filter(FilterOperation.contains, 'name'), 
    };
    
    if(filter && filter != ""){
      filters.name = new Filter(FilterOperation.contains, 'name', "", filter);
    }
    
    let response = await firstValueFrom(this.capabilitiesService.all({filter: FilterBuilder.fromObject(filters).build() ,page: {number: 1, size: 100}, sort: ['name']}));
    this.capabilities = response.data;
  }

  async save() {
   // let valid = this.formValidationService.validateForm(this.contractCapabilityFormGroup);
   // if (valid) {
  if(this.selectedCapabilitiesIds.length > 0){
      for (const element of this.selectedCapabilitiesIds) {
        var c = new ContractCapability();
        c.capabilityId = element.id;
        c.contractId = this.contractCapability.contractId;
        c.normalServiceAllowed = this.contractCapability.normalServiceAllowed;
        c.guardServiceAllowed = this.contractCapability.guardServiceAllowed;
        c.guardPercentIncrement = this.contractCapability.guardPercentIncrement;
        await firstValueFrom(this.contractCapabilitiesService.save(c));
      }
      this.dynamicDialogRef.close();
      var message = "Especialidad guardada correctamente";
      if(this.selectedCapabilitiesIds.length > 1) message = "Especialidades guardadas correctamente";
      this.messageService.add({ severity: 'success', summary: 'Éxito', detail: message });

      /*this.contractCapability = Object.assign(this.contractCapability, this.contractCapabilityFormGroup.value);      
      await this.contractCapabilitiesService.save(this.contractCapability).subscribe({
        next: (data) => {
          this.messageService.add({ severity: 'success', summary: 'Éxito', detail: 'Especialidad guardada correctamente' });
          this.dynamicDialogRef.close();
        },
        error: (error) => {
          this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Error al guardar la especialidad' });
        }
      });*/
    } else {
      document.getElementById('form')?.classList.add('formInvalid');
    }
  }
  cancel() {
    this.dynamicDialogRef.close();
  }

  delete() {
    this.confirmationService.confirm({
      message: "¿Está seguro que desea eliminar la especialidad?",
      header: "Eliminar especialidad",
      acceptLabel: "Aceptar",
      rejectLabel: "Cancelar",
      acceptButtonStyleClass: "p-button-danger",
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        this.contractCapabilitiesService.delete(this.contractCapability.id).subscribe({
          next: (data: any) => {
            this.cancel();
            this.messageService.add({ closable: true, severity: 'success', detail: "Especialidad eliminada correctamente." });
          },
          error: (error: any) => {
            this.messageService.add({ closable: true, severity: 'error', detail: error.error.title });
          }
        });
      }
    });
  }
}
